export default {
    data: () => ({
        translations: {
            totalPOints: {
                el: "ΣΥΝΟΛΟ ΠΟΝΤΩΝ",
                en: "TOTAL POINTS",
                it: "PUNTI TOTALI"
            },
            availableCoupons: {
                el: "Έχετε διαθέσιμα κουπόνια για εξαργύρωση!",
                en: "You have available coupons for redemption!",
                it: "Hai a disposizione dei coupon da riscuotere!"
            }
        }
    })
};
